var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/Share Screen/Share Screen On"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.257 8C22.257 6.48122 21.0258 5.25 19.507 5.25H6.60718C5.0884 5.25 3.85718 6.48121 3.85718 8V15.6403C3.85718 17.1591 5.08839 18.3903 6.60718 18.3903H9.68203C10.0962 18.3903 10.432 18.0545 10.432 17.6403C10.432 17.2261 10.0962 16.8903 9.68203 16.8903H6.60718C5.91682 16.8903 5.35718 16.3307 5.35718 15.6403L5.35718 8C5.35718 7.30964 5.91682 6.75 6.60718 6.75L19.507 6.75C20.1973 6.75 20.757 7.30964 20.757 8V15.6403C20.757 16.3307 20.1973 16.8903 19.507 16.8903H16.807C16.3928 16.8903 16.057 17.2261 16.057 17.6403C16.057 18.0545 16.3928 18.3903 16.807 18.3903H19.507C21.0258 18.3903 22.257 17.1591 22.257 15.6403V8Z",
    fill: "#2B313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06485 13.307C8.70353 13.6683 8.70353 14.2541 9.06485 14.6154C9.42617 14.9768 10.012 14.9768 10.3733 14.6154L12.2634 12.7253V19.564C12.2634 20.075 12.6776 20.4892 13.1886 20.4892C13.6996 20.4892 14.1138 20.075 14.1138 19.564L14.1138 12.7253L16.004 14.6154C16.3653 14.9768 16.9511 14.9768 17.3124 14.6154C17.6737 14.2541 17.6737 13.6683 17.3124 13.307L13.8429 9.83742C13.6693 9.66391 13.434 9.56643 13.1886 9.56643C12.9432 9.56643 12.7079 9.66391 12.5344 9.83742L9.06485 13.307Z",
    fill: "#2B313C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.950c039c4807d4933828fe2bd7d2faff.svg";
export { ForwardRef as ReactComponent };